import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setDivisionalApproverRequisitionType } from 'Store/OrderManagement/DivisionalApproverRequisitionType/DivisionalApproverRequisitionTypeActions';
import { GET_DIVISIONAL_APPROVER_REQUISITION_TYPE } from 'Store/OrderManagement/DivisionalApproverRequisitionType/DivisionalApproverRequisitionTypeType';
import OrderManagementApiService from './OrderManagementApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getDivisionalApproverRequisitionType(): any {
    try {
        yield put(globalLoaderText("Fetching DropDown Data...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint : `orderapproval/dropdown/processtypes`,
            apiMethod :  apiMethod.GET,
            payload : null
            
        }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
        );
        if (response) {
            yield put(setDivisionalApproverRequisitionType(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setDivisionalApproverRequisitionType([]))
        yield put(globalLoaderText(""));
    }
}

function* watchReasonCode() {
    yield takeEvery(GET_DIVISIONAL_APPROVER_REQUISITION_TYPE, getDivisionalApproverRequisitionType);
}

export default function* combinedSaga() {
    yield all([
        watchReasonCode()
    ])
}
